<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>费率管理</el-breadcrumb-item>
          <el-breadcrumb-item>编辑费率</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="content-box">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="费率信息" name="account">
            <div class="tab-content">
              <el-form
                ref="editForm1"
                :model="model"
                :rules="rules"
                :label-position="labelPosition"
              >
                <el-form-item label="所属客户" label-width="120px">
                  <cn-select-search
                    style="text-align: left"
                    ref="child"
                    v-model="model.companyId"
                    :v_disabled="disabled"
                    :data="companyList"
                    @val="setCompanyId"
                    placeholder="请筛选客户..."
                  >
                  </cn-select-search>
                </el-form-item>

                <el-form-item
                  prop="feeName"
                  label="费率名称"
                  label-width="120px"
                >
                  <el-input v-model="model.feeName" placeholder=""></el-input>
                </el-form-item>
                <el-form-item
                  prop="remark"
                  label="费率备注"
                  label-width="120px"
                >
                  <el-input v-model="model.remark" placeholder=""></el-input>
                </el-form-item>

                <el-row class="card-form">
                  <el-col>
                    <el-card shadow="hover">
                      <div slot="header" class="clearfix">
                        <span>时段设置/最大充电功率</span>
                      </div>

                      <div class="">
                        <el-time-select
                          class="myselect"
                          v-model="form.startTime"
                          :picker-options="{
                            start: '00:00',
                            step: '00:30',
                            end: '24:00',
                          }"
                          @change="selectedTime"
                          placeholder="选择时间"
                        >
                        </el-time-select>
                        <span style="margin: 0 10px 22px">至</span>

                        <el-time-select
                          class="myselect"
                          v-model="form.endTime"
                          :picker-options="{
                            start: '00:00',
                            step: '00:30',
                            end: '24:00',
                            minTime: form.startTime,
                          }"
                          @change="selectedTime"
                          placeholder="选择时间"
                        >
                        </el-time-select>

                        <el-input
                          v-model="form.maxPower"
                          style="width: 100px"
                          placeholder="最大充电功率"
                        ></el-input>
                        kW

                        <el-button
                          type="primary"
                          @click="handleAdd"
                          style="margin: 0 10px 22px"
                          >添加</el-button
                        >
                      </div>

                      <div class="dl-box">
                        <ul>
                          <li
                            style="margin-bottom: 12px"
                            v-for="(fee, index) in model.feeShowList"
                            :key="index"
                          >
                            {{ fee.startTime }}
                            <span style="margin: 0 10px 22px">至</span>
                            {{ fee.endTime }}
                            <span style="margin: 0 10px 22px"></span>
                            <el-select
                              v-model="fee.controlMode"
                              class="myselect"
                              placeholder="请选择..."
                              style="width: 18%"
                            >
                              <el-option
                                v-for="item in modeList"
                                :key="item.id"
                                :label="item.title"
                                :value="item.id"
                              >
                              </el-option>
                            </el-select>

                            <el-select
                              v-model="fee.periodType"
                              class="myselect"
                              placeholder="请选择..."
                              style="width: 18%"
                            >
                              <el-option
                                v-for="item in feeList"
                                :key="item.id"
                                :label="item.title"
                                :value="item.id"
                              >
                              </el-option>
                            </el-select>

                            <el-input
                              v-model="fee.maxPower"
                              style="width: 15%"
                              placeholder="最大充电功率"
                            ></el-input>
                            kW

                            <el-button
                              type="primary"
                              @click="handleDelete(index)"
                              style="margin: 0 10px 22px"
                              >删除</el-button
                            >
                          </li>
                        </ul>
                      </div>
                    </el-card>
                  </el-col>
                  <el-col style="max-width: 300px">
                    <el-card shadow="hover">
                      <div slot="header" class="clearfix">
                        <span>费用设置</span>
                      </div>
                      <div class="dl-box-fee">
                        <el-form-item prop="fee1" label="尖时">
                          <el-input
                            style="width: 100px"
                            v-model="model.fee1"
                            placeholder=""
                          ></el-input>
                          元
                        </el-form-item>
                        <el-form-item prop="fee2" label="峰时">
                          <el-input
                            style="width: 100px"
                            v-model="model.fee2"
                            placeholder=""
                          ></el-input>
                          元
                        </el-form-item>
                        <el-form-item prop="fee3" label="平时">
                          <el-input
                            style="width: 100px"
                            v-model="model.fee3"
                            placeholder=""
                          ></el-input>
                          元
                        </el-form-item>
                        <el-form-item prop="fee4" label="谷时">
                          <el-input
                            style="width: 100px"
                            v-model="model.fee4"
                            placeholder=""
                          ></el-input>
                          元
                        </el-form-item>
                        <el-form-item prop="fee5" label="高尖时">
                          <el-input
                            style="width: 100px"
                            v-model="model.fee5"
                            placeholder=""
                          ></el-input>
                          元
                        </el-form-item>
                      </div>
                    </el-card>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="footer-box">
        <div class="footer-btn">
          <el-button type="primary" @click="submitForm('editForm')"
            >确认保存</el-button
          >
          <el-button plain @click="resetForm">取消返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../js/upload.component.js";
import "../../js/select.component.js";
import { AxiosAjax, getCompanyData } from "../../js/axios.config";

let self = this;
export default {
  data() {
    return {
      disabled: true,
      activeName: "account", //当前选项卡
      labelPosition: "right", //表单对齐方式
      modeList: [
        { id: -1, title: "请选择..." },
        { id: 1, title: "充电" },
        { id: 2, title: "放电" },
        { id: 3, title: "空闲" },
      ], //模式列表
      feeList: [
        { id: -1, title: "请选择..." },
        { id: 1, title: "尖时" },
        { id: 2, title: "峰时" },
        { id: 3, title: "平时" },
        { id: 4, title: "谷时" },
        { id: 5, title: "高尖时" },
      ], //模式列表
      companyList: [], //公司列表
      form: {
        startTime: null,
        endTime: null,
      },
      model: {
        gmtCreate: "2022-02-10 13:39:52",
        createdBy: "system",
        modifiedBy: "system",
        gmtModified: "2022-02-14 16:56:00",
        id: "",
        feeName: "",
        companyId: "",
        fee1: 0,
        fee2: 0,
        fee3: 0,
        fee4: 0,
        fee5: 0,
        remark: "",
        feeShowList: [],
      },
      type: 0, //1复制 2修改
      rules: {
        feeName: [{ required: true, message: "必填项", trigger: "blur" }],
        companyId: [{ required: true, message: "必填项", trigger: "blur" }],
        fee1: [{ required: true, message: "必填项", trigger: "blur" }],
        fee2: [{ required: true, message: "必填项", trigger: "blur" }],
        fee3: [{ required: true, message: "必填项", trigger: "blur" }],
        fee4: [{ required: true, message: "必填项", trigger: "blur" }],
        fee5: [{ required: true, message: "必填项", trigger: "blur" }],
      },
    };
  },
  methods: {
    //初始化数据
    initData: function () {
      let _this = this; //当前页面
      let id = _this.$route.query.id || ""; //获取ID
      this.type = _this.$route.query.type || ""; //获取ID

      if (id) {
        AxiosAjax({
          url: "/cabinet/feeConfig/" + id,
          loading: true,
          success: function (res) {
            //赋值给model
            Object.keys(_this.model).forEach((key) => {
              _this.model[key] = res.data.data[key];
            });

            _this.$refs.child.valueId = _this.model.companyId;
            _this.$refs.child.reset();

            //    if (cp) {
            //        console.log("------+");
            //        _this.model.feeName = "";
            //        _this.model.id = "0";
            //    }
          },
        });
      } else {
        _this.model.companyId =
          window.localStorage.getItem("fx_login_companyId");
      }

      _this.companyList = getCompanyData();

      if (window.localStorage.getItem("fx_login_companyType") == "0") {
        _this.disabled = false;
      }
    },
    submitForm: function () {
      let _this = this; //当前页面

      var bol = "";
      for (let i = 0; i < _this.model.feeShowList.length; i++) {
        if (_this.model.feeShowList[i].startTime == "00:00") {
          bol += "Y";
        }

        if (_this.model.feeShowList[i].endTime == "24:00") {
          _this.model.feeShowList[i].endTime = "23:59";
          bol += "Y";
        }
      }

      console.log(bol);

      if (bol != "YY") {
        _this.$message({
          type: "warning",
          message: "请已 00:00 到 24:00 结束...",
        });

        return;
      }

      //多个表单验证
      const f1 = new Promise((resolve, reject) => {
        _this.$refs["editForm1"].validate((valid) => {
          if (valid) resolve();
        });
      });
      console.log(_this.model.id);
      Promise.all([f1]).then(() => {
        //提交表单,Id大于0则修改，否则添加
        if (_this.model.id > "0" && _this.type == 2) {
          AxiosAjax({
            method: "put",
            url: "/cabinet/feeConfig/update",
            data: _this.model,
            loading: true,
            successMsg: "修改费率成功",
            success: function (res) {
              //可跳转加列表页
              _this.$router.push({ name: "FeeConfigList" });
            },
          });
        } else {
          AxiosAjax({
            method: "post",
            url: "/cabinet/feeConfig/save",
            data: _this.model,
            loading: true,
            successMsg: "新增费率成功",
            success: function (res) {
              //重置表单
              //_this.$refs['editForm1'].resetFields();
              //可跳转加列表页
              _this.$router.push({ name: "FeeConfigList" });
            },
          });
        }
      });
    },
    resetForm() {
      window.history.back(-1);
    },
    handleAdd() {
      var _this = this;

      var _bol = false;
      var _endTime = "";
      for (let i = 0; i < _this.model.feeShowList.length; i++) {
        _endTime = _this.model.feeShowList[i].endTime;
      }

      if (_endTime == "") {
        if ("00:00" == _this.form.startTime) {
          _bol = true;
        }
      } else {
        if (_endTime == _this.form.startTime) {
          _bol = true;
        }
      }

      if (_bol) {
        _this.model.feeShowList.push({
          startTime: _this.form.startTime,
          endTime: _this.form.endTime,
          controlMode: 3,
          periodType: 3,
          remark: "",
        });
      } else {
        _this.$message({
          type: "warning",
          message: "要按顺序添加时间...",
        });
      }
    },
    handleDelete(index) {
      var _this = this;

      var ls = [];

      for (let i = 0; i < _this.model.feeShowList.length; i++) {
        if (i != index) {
          ls.push(_this.model.feeShowList[i]);
        }
      }

      _this.model.feeShowList = ls;
    },
    selectedTime() {
      if (this.startTime && this.endTime) {
        this.addErrMsg = null;
      }
    },
    setCompanyId: function (obj) {
      this.model.companyId = obj.toString();
    },
  },
  created: function () {
    //初始化数据
    this.initData();
  },
  mounted: function () {
    var _this = this;

    _this.$refs.child.valueId = _this.model.companyId;
    _this.$refs.child.reset();
  },
};
</script>
<style scoped>
.dl-box-fee .el-input {
  width: 20%;
}
.dl-box-fee /deep/ .el-form-item__label {
  min-width: 80px;
}
.dl-box .el-form-item__label {
  font-weight: bold;
}
.el-date-editor.el-input {
  width: 150px;
}
.myselect .el-input {
  width: 100px;
}
.card-form {
  display: flex;
}
.card-form /deep/ .el-col {
  flex: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/FeeConfig/FeeConfigEdit.vue